// Google Analytics integration
export const GA_MEASUREMENT_ID = 'G-C0JLCKT7YS';

// Initialize Google Analytics
export const initGA = () => {
  // Check if gtag is already loaded
  if (window.gtag) return;

  // Load gtag.js script
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  // Initialize dataLayer and gtag
  window.dataLayer = window.dataLayer || [];
  window.gtag = function() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID, {
    anonymize_ip: true, // Anonymize IP for GDPR compliance
    cookie_flags: 'SameSite=None;Secure'
  });

  console.log('✅ Google Analytics initialized');
};

// Track page views
export const trackPageView = (url) => {
  if (window.gtag) {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: url,
    });
  }
};

// Track custom events
export const trackEvent = (action, category, label, value) => {
  if (window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};
